// fetchOrders.js
import { message } from "antd";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";
import { token } from "../../constants/Constants";
import { fetchAdminOrders } from "../../endpoints/API";
// import { useSelector } from "react-redux";

export const fetchOrders = async (setOrders, baseUrl, prodTestUrl) => {

  try {
    const response = await fetchAdminOrders();
    if (response.statusText=="OK") {
      const data =response?.data;
      setOrders(data);
    } else {
      message.error("Failed to fetch orders.");
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching orders.");
  }
};
